export enum TYPES {
  ALL = "all",
  CONSUMER = "consumer",
  BUSINESS = "business",
  MANIA = "mania",
}

export const TYPES_NAME = {
  [TYPES.ALL]: "全会員",
  [TYPES.CONSUMER]: "一般会員",
  [TYPES.BUSINESS]: "業者会員",
  [TYPES.MANIA]: "愛好家",
};

export const TYPES_ARRAY = [
  { id: TYPES.ALL, name: TYPES_NAME[TYPES.ALL] },
  { id: TYPES.CONSUMER, name: TYPES_NAME[TYPES.CONSUMER] },
  { id: TYPES.BUSINESS, name: TYPES_NAME[TYPES.BUSINESS] },
  { id: TYPES.MANIA, name: TYPES_NAME[TYPES.MANIA] },
];

export enum STATUS {
  EDIT = "edit",
  WAIT = "wait",
  SEND = "send",
}

export const STATUS_NAME = {
  [STATUS.EDIT]: "編集中",
  [STATUS.WAIT]: "送信待ち",
  [STATUS.SEND]: "送信済",
};
